import React from 'react'
import PropTypes from 'prop-types'
import { imageMap, labelMap } from 'src/pages/main/house/const/houseConstants'

const LabelRank = ({ type }) => {
  const imageSrc = imageMap[type] || imageMap.bronze
  const label = labelMap[type] || labelMap.bronze

  return (
    <div className="relative">
      <div className="w-full px-3 py-1.5 text-[8px] xs:text-xs font-medium text-white tracking-wider rounded-[10px] bg-house-black">
        現在のランク：{label}
      </div>
      <span className="absolute -bottom-1/2 right-2 w-14 xs:w-16">
        <img className="w-full h-full" src={imageSrc} alt="rank" />
      </span>
    </div>
  )
}

LabelRank.propTypes = {
  type: PropTypes.oneOf(['bronze', 'silver', 'gold']),
  width: PropTypes.string
}

export default LabelRank
